
import { useState, useEffect, useRef } from 'react';
import axios from 'axios'
import ToastNotification from '../../../components/ToastNotification';


function Banner() {

  const [toast, setToast] = useState({ show: false, message: '', bg: 'success' });
  const showToast = (msg, bg = 'success') => {
    setToast({ show: true, message: msg, bg });
  };
  const fileInputRef = useRef(null);
  const [bannerFile, setBannerFile] = useState(null);
  const [currentBanner, setCurrentBanner] = useState([]);
  const [activeIndex, setActiveIndex] = useState(0);

  const [index, setIndex] = useState(0);
const [showForm, setShowForm] = useState(false);
const [confirmDelete, setConfirmDelete] = useState({
  show: false,
  bannerId: null
});


  const handleFileChange = (e) => {
    const file = e.target.files[0];

    if (!file) return;

    if (!["image/jpeg", "image/png"].includes(file.type)) {
      setToast("Only JPG and PNG images are allowed.", "warning");
      e.target.value = null;
      return;
    }

    const fileSizeInMB = file.size / (1024 * 1024);
    if (fileSizeInMB > 2) {
      setToast("File size is too large! Please upload a file smaller than 2MB.", "danger");

      e.target.value = null;
      return;
    }
    setBannerFile(file);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!bannerFile) {
      showToast("Please select a banner image.",'warning');
      return;
    }

    try {
      const formData = new FormData();
      formData.append("image", bannerFile);

      const response = await axios.post(
        "https://api.skyguard.group/api/banner",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      showToast('Banner uploaded successfully!', 'success');
      setBannerFile(null);
      fetchBanner();

      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }

    } catch (error) {
      console.error("Upload failed:", error);
      showToast('Failed to upload banner.', 'danger');
    }
  };

  useEffect(() => {
    fetchBanner();
  }, []);



  const fetchBanner = async () => {
    try {
      const res = await axios.get("https://api.skyguard.group/api/fetch-banner");
      setCurrentBanner(res.data);
    } catch (error) {
      console.error("Failed to fetch banner", error);
      setCurrentBanner([]);
    }
  };


  const handleRemoveBanner = async (bannerId) => {
    try {
      await axios.delete(`https://api.skyguard.group/api/delete-banner/${bannerId}`);

      setCurrentBanner(prev =>
        prev.filter(banner => banner.id !== bannerId)
      );
      showToast("Banner deleted successfully!", 'success');
      fetchBanner();
    } catch (error) {
      console.error(error);
      showToast("Failed to remove the banner", 'danger');
    }
  };

  useEffect(() => {
    if (!Array.isArray(currentBanner) || currentBanner.length === 0) return;

    const interval = setInterval(() => {
      setActiveIndex(prevIndex => (prevIndex + 1) % currentBanner.length);
    }, 3000); 

    return () => clearInterval(interval); 
  }, [currentBanner]);

  return (

    <div className="main-section">
  <ToastNotification
    show={toast.show}
    message={toast.message}
    bg={toast.bg}
    onClose={() => setToast({ ...toast, show: false })}
  />

  <div className="container-fluid dashboard-wrapper p-3 bg-body-secondary">
    <h3 className="my-3 fw-bold fs-5 golos">Banner Management</h3>

    <div className="container mt-4">
      {/* Slider Section */}
      {Array.isArray(currentBanner) && currentBanner.length > 0 ? (
        <div style={{ position: "relative", maxWidth: "900px", margin: "0 auto" }}>
          <img
            src={`https://api.skyguard.group/uploads/${currentBanner[activeIndex].img.replace(/\\/g, "/")}`}
            alt={`Banner ${currentBanner[activeIndex].id}`}
            style={{
              width: "100%",
              height: "400px",
              objectFit: "cover",
              borderRadius: "8px",
              transition: "opacity 0.5s ease-in-out"
            }}
          />

          {/* Remove Button */}
          <button
            // onClick={() => handleRemoveBanner(currentBanner[activeIndex].id)}
             onClick={() => setConfirmDelete({ show: true, bannerId: currentBanner[activeIndex].id })}
            style={{
              position: "absolute",
              top: "10px",
              right: "10px",
              background: "rgba(255,0,0,0.7)",
              color: "#fff",
              border: "none",
              padding: "6px 12px",
              cursor: "pointer",
              borderRadius: "4px",
              zIndex: 1000
            }}
          >
            Remove
          </button>

          {/* Prev / Next Buttons */}
          <button
            onClick={() =>
              setActiveIndex(activeIndex === 0 ? currentBanner.length - 1 : activeIndex - 1)
            }
            style={{
              position: "absolute",
              top: "50%",
              left: "10px",
              transform: "translateY(-50%)",
              background: "rgba(0,0,0,0.5)",
              color: "#fff",
              border: "none",
              padding: "8px 12px",
              cursor: "pointer",
              borderRadius: "4px"
            }}
          >
            Prev
          </button>

          <button
            onClick={() => setActiveIndex((activeIndex + 1) % currentBanner.length)}
            style={{
              position: "absolute",
              top: "50%",
              right: "10px",
              transform: "translateY(-50%)",
              background: "rgba(0,0,0,0.5)",
              color: "#fff",
              border: "none",
              padding: "8px 12px",
              cursor: "pointer",
              borderRadius: "4px"
            }}
          >
            Next
          </button>

          <p style={{ textAlign: "center", marginTop: "8px" }}>
            {activeIndex + 1} / {currentBanner.length}
          </p>
        </div>
      ) : (
        <p className="text-center text-muted">No banners uploaded yet.</p>
      )}

      {/* Add Banner Button */}
      {!showForm && (
        <div className="text-center my-4">
          <button
            className="btn btn-primary"
            onClick={() => setShowForm(true)}
          >
            Add New Banner
          </button>
        </div>
      )}

      {/* Upload Banner Form */}
      {showForm && (
        <div className="row justify-content-center mt-4">
          <div className="col-12 col-sm-10 col-md-6 col-lg-5">
            <div className="card shadow-sm p-4 border-0">
              <div className="card-body">
                <h5 className="text-center mb-3">Upload Banner</h5>
                <form onSubmit={handleSubmit}
             
                >
                  <div className="col-12 mb-3">
                    <label className="form-label fw-medium">Upload File</label>
                    <input
                      type="file"
                      className="form-control"
                      accept="image/jpeg, image/png"
                      onChange={(e) => setBannerFile(e.target.files[0])}
                    />
                  </div>

                  <div className="d-flex justify-content-center gap-2 mt-3">
                    <button type="submit" className="btn btn-success px-4">
                      Save
                    </button>
                    <button
                      type="button"
                      className="btn btn-secondary px-4"
                      onClick={() => setShowForm(false)}
                    >
                      Cancel
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>

    {confirmDelete.show && (
  <div
    className="modal fade show"
    style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
    tabIndex="-1"
  >
    <div className="modal-dialog modal-dialog-centered">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">Confirm Delete</h5>
          <button
            type="button"
            className="btn-close"
            onClick={() => setConfirmDelete({ show: false, bannerId: null })}
          ></button>
        </div>
        <div className="modal-body">
          <p>Are you sure you want to delete this banner?</p>
        </div>
        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-secondary"
            onClick={() => setConfirmDelete({ show: false, bannerId: null })}
          >
            Cancel
          </button>
          <button
            type="button"
            className="btn btn-danger"
            onClick={() => {
              handleRemoveBanner(confirmDelete.bannerId);
              setConfirmDelete({ show: false, bannerId: null });
            }}
          >
            Yes, Delete
          </button>
        </div>
      </div>
    </div>
  </div>
)}

  </div>
</div>


  )
}

export default Banner